var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.5;fill:#000000;enable-background:new    ;}\n\t.st1{fill:#000000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1192",
    transform: "translate(43.574 405.091) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    className: "st0",
    d: "M17.8-81.1v460.4c0.9,13.3-9.2,24.9-22.5,25.8c-1.1,0.1-2.2,0.1-3.3,0h-127.7v-51.3h102.4 V-55.7h-102.4v-51.2h128c13.3-0.8,24.8,9.4,25.6,22.7C17.9-83.1,17.9-82.1,17.8-81.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    className: "st1",
    d: "M-281.5,3.2c-9.9,9.4-10.3,25.1-0.8,35c0.3,0.3,0.6,0.6,0.8,0.8l84.4,84.4h-219.9 c-13.3-0.9-24.9,9.2-25.8,22.5c-0.1,1.1-0.1,2.2,0,3.3c-0.9,13.3,9.2,24.9,22.5,25.8c1.1,0.1,2.2,0.1,3.3,0H-197l-84.4,84.1 c-9.6,10.2-9.1,26.2,1.1,35.8c9.8,9.2,25,9.2,34.7,0l127.9-128c9.9-9.4,10.3-25.1,0.8-35c-0.3-0.3-0.6-0.6-0.8-0.8L-245.7,3.2 c-9.4-9.9-25.1-10.3-35-0.8C-280.9,2.6-281.2,2.9-281.5,3.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIconDark);
export default __webpack_public_path__ + "static/media/login-icon-dark.53587f05c98f5032ecd0e5223988fc54.svg";
export { ForwardRef as ReactComponent };